import { render } from "./Documentazione.vue?vue&type=template&id=dd946b7a&scoped=true"
import script from "./Documentazione.vue?vue&type=script&lang=js"
export * from "./Documentazione.vue?vue&type=script&lang=js"

import "./Documentazione.vue?vue&type=style&index=0&id=dd946b7a&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd946b7a"]])

export default __exports__